import {
    SET_VEHICLE_TYPES,
    GET_VEHICLE_TYPES
} from './vehicleTypes.types';

import { AnyAction, Reducer } from 'redux';
import { VehicleTypeState } from 'models/redux/vehicleTypes.state';

const initialState: VehicleTypeState = {
    vehicleTypes: [],
    loading: false
}

const reducer: Reducer<VehicleTypeState> = (
    state: VehicleTypeState = initialState,
    action: AnyAction = { type: undefined },
) => {
    switch (action.type) {
        case GET_VEHICLE_TYPES:
            return { ...state, loading: true };

        case SET_VEHICLE_TYPES:
            return { ...state, ...action.payload, loading: false };

        default:
            return state;
    }
};

export default reducer;
